import { maxWidth, noTouch } from '@/assets/styles/mixins.css.js'
import { loadableStyles } from '@/assets/styles/global.css'
import Content from "./StyledContent";
import styled from 'styled-components'
import vars from '@/assets/styles/vars'

const Article = styled.article`
  --common-transition-time: 0.3s;

  position: relative;
  display: flex;
  flex-direction: column;


  ${loadableStyles}
`

Article.Bg = styled.div`
`

Article.Img = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  overflow:hidden;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 360px;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: 0.3s;
  }

    ${noTouch()`
    ${Article}:hover & {
      & img {
        transform:scale(1.05);
      }
    }
  `}
`

Article.Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 26px 0;

  ${maxWidth(vars.breakpoints.tablet)`
    position: relative;
    padding: 18px 0;
  `}
`

Article.Title = styled.h3`
  --article-title-font-size: 20px;
  --article-title-line-height: 1.4;
  --article-title-max-lines: 3;

  order: 1;
  display: block;
  display: -webkit-box;
  max-height: calc(
    var(--article-title-font-size) * var(--article-title-line-height) *
      var(--article-title-max-lines)
  );
  -webkit-line-clamp: var(--article-title-max-lines);
  -moz-line-clamp: var(--article-title-max-lines);
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 16px;
  font-weight: 500;
  font-size: var(--article-title-font-size);
  line-height: var(--article-title-line-height);
  color: var(--article-title-color, var(--color-main));

  ${maxWidth(vars.breakpoints.tablet)`
    --article-title-font-size: 18px;
    padding-right: 52px;
  `}
`

Article.Desc = styled.div`
  order: 2;
  ${Content.Html} {
  --article-title-font-size: 16px;
    --article-title-line-height: 1.2;
    --article-title-max-lines: 4;
    
    display: block;
    display: -webkit-box;
    max-height: calc(
      var(--article-title-font-size) * var(--article-title-line-height) *
        var(--article-title-max-lines)
    );
    -webkit-line-clamp: var(--article-title-max-lines);
    -moz-line-clamp: var(--article-title-max-lines);
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 16px;
    font-weight: normal;
    font-size: var(--article-title-font-size);
    line-height: var(--article-title-line-height);
    color: var(--article-title-color, var(--color-main));
     * {
        font-size: var(--article-title-font-size) !important;
        line-height: var(--article-title-line-height) !important;
        font-weight: normal !important;
        color: var(--article-title-color, var(--color-main)) !important;
      }

    ${maxWidth(vars.breakpoints.tablet)`
      --article-title-font-size: 15px;
    `}
  }
`

Article.Date = styled.div`
  order: 3;
  margin: auto 0 0;
  font-weight: normal;
  font-size: 14px;
  line-height: 1.6;
  color: var(--article-date-color, var(--color-extra));
`

Article.Arrow = styled.div`
  --arrow-btn-shadow-content: none;

  position: absolute;
  top: 24px;
  right: 24px;
  order: 3;
  font-size: 0;
  color: var(--article-arrow-color, #fff);
  opacity: 0;
  transform: translateX(-6px);
  transition: opacity var(--common-transition-time) ease-in,
    transform var(--common-transition-time) ease-in;

  svg {
    vertical-align: middle;
    width: 20px;
    height: auto;
    transform: rotate(180deg);
  }

  ${noTouch()`
    ${Article}:hover & {
      opacity: 1;
      transform: none;
    }
  `}

  ${maxWidth(vars.breakpoints.tablet)`
    --arrow-btn-bg: rgba(0, 0, 0, 0);
    --arrow-btn-color: var(--color-decor);

    top: 10px;
    right: 8px;
    opacity: 1;
    transform: none;
  `}
`

Article.Link = styled.a`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`

export default Article
